<mat-dialog-content class="info-wrapper">
  <header class="header" [class]="textClasses()">
    {{ 'shared.dialogs.bounced-email.header' | transloco }}
  </header>
  <div class="email" [class]="emailClasses()">{{ data?.email }}</div>
  <div class="description" [class]="textClasses()">
    {{ 'shared.dialogs.bounced-email.description' | transloco }}
  </div>
</mat-dialog-content>
<mat-dialog-actions class="actions">
  <button [mat-dialog-close]="true" mat-flat-button color="primary">
    {{ 'shared.dialogs.bounced-email.update-btn' | transloco }}
    <mat-icon>arrow_forward</mat-icon>
  </button>
  <button mat-dialog-close mat-flat-button>
    {{ 'shared.dialogs.bounced-email.correct-btn' | transloco
    }}<mat-icon>arrow_forward</mat-icon>
  </button>
</mat-dialog-actions>
